export default __webpack_public_path__ + "static/media/cybermgmtW.9daee453.png";